import React, {useEffect, useRef} from 'react';

const CalciteSelect = ({onSelectChange, children, ...props}) => {
  const selectRef = useRef(null);

  useEffect(() => {
    const selectElement = selectRef.current;
    const onSelectChangeHandler = onSelectChange;

    if (onSelectChangeHandler) selectElement.addEventListener('calciteSelectChange', onSelectChangeHandler);

    return () => {
      if (onSelectChangeHandler) selectElement.removeEventListener('calciteSelectChange', onSelectChangeHandler);
    };
  }, [onSelectChange]);

  return (
    <calcite-select ref={selectRef} {...props} class={props.className}>
      {children}
    </calcite-select>
  );
};

export default CalciteSelect;
